import { create } from 'zustand'

interface CartUIInternal {
  isOpen: boolean
}

export const _cartUI = create<CartUIInternal>(() => ({
  isOpen: false,
}))

export const cartUI = {
  get isOpen(): boolean { return _cartUI.getState().isOpen },
  open: () => _cartUI.setState({ isOpen: true }),
  close: () => _cartUI.setState({ isOpen: false }),
  toggle: () => _cartUI.setState({ isOpen: !_cartUI.getState().isOpen }),
}